import lottie from 'lottie-web';
import loaderAnimation from '../lotties/loader.json';

const instances = new WeakMap();

export function mountArmeniansLoader(container, targetEl = null) {
    const mountTarget = targetEl
        || container?.querySelector('[data-armenians-loader]')
        || container;

    if (!mountTarget) {
        return null;
    }

    const existing = instances.get(mountTarget);
    if (existing) {
        return existing;
    }

    const animation = lottie.loadAnimation({
        container: mountTarget,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: loaderAnimation,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid meet',
        },
    });

    instances.set(mountTarget, animation);

    return animation;
}

export function unmountArmeniansLoader(targetEl) {
    const animation = instances.get(targetEl);

    if (!animation) {
        return;
    }

    animation.destroy();
    instances.delete(targetEl);
}

export function initArmeniansLoaders(root = document) {
    root.querySelectorAll('[data-armenians-loader]:not([data-lottie-mounted])').forEach((element) => {
        element.setAttribute('data-lottie-mounted', '1');
        mountArmeniansLoader(null, element);
    });
}
